// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'mutations' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').SnackConfig} SnackConfig
 */

/**
 * @param {State} state
 * @param {SnackConfig[]} obj
 */
export function setQueue (state, obj) {
  state.queue = obj || [];
}
